export default __webpack_public_path__ + "static/media/ameaBlack.fd5381f9.svg";